'use client';

import { type FC, type ReactNode } from 'react';
import { BottomSheet } from '../../ui';
import { AtlasIcon } from './shared/AtlasIcon';
import { FaPlus } from '../../icons';
import { StanceText } from './howto/StanceText';
import { GRENADE_ICON_SRC, SMOKE_ICON_SRC, FLASH_ICON_SRC, KNIFE_ICON_SRC } from '../spriteLayout';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './RushMid.translations';
import { useGearInfo } from './useGearInfo';

const Row: FC<{ icon: ReactNode; title: string; info: string }> = ({ icon, title, info }) => (
  <div className="flex items-start gap-3 rounded-2xl border border-white/10 bg-bg-secondary p-3">
    <div className="flex h-9 w-9 shrink-0 items-center justify-center">{icon}</div>
    <div className="min-w-0">
      <div className="text-sm font-semibold text-label-primary">{title}</div>
      {/* [[stance|Слово]]-токены в строке → инлайн-бейджи стоек, как в правилах/советах */}
      <div className="mt-0.5 text-xs leading-relaxed text-label-secondary"><StanceText text={info} /></div>
    </div>
  </div>
);

/** Числовая шпаргалка по снаряжению — числа из {@link useGearInfo} (константы battle-sim). */
export const GearInfoSheet: FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  const { t } = useLocalTranslation(translations);
  const gear = useGearInfo();
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('gearInfoTitle')} heightClass="h-auto max-h-[80vh]">
      <div className="space-y-2 px-4 pb-6">
        <Row icon={<AtlasIcon src={GRENADE_ICON_SRC} size={28} />} title={t('nadeFrag')} info={gear.frag} />
        <Row icon={<AtlasIcon src={SMOKE_ICON_SRC} size={28} />} title={t('nadeSmoke')} info={gear.smoke} />
        <Row icon={<AtlasIcon src={FLASH_ICON_SRC} size={28} />} title={t('flash')} info={gear.flash} />
        <Row icon={<FaPlus className="text-accent-green" size={18} />} title={t('medkit')} info={gear.medkit} />
        <Row icon={<AtlasIcon src={KNIFE_ICON_SRC} size={28} />} title={t('knife')} info={gear.knife} />
      </div>
    </BottomSheet>
  );
};
